export default "__VITE_ASSET__D67XoYT6__"